// @ts-nocheck
import t from './catalog.types';

const initialState = {
  provider: 'esp',
  selectedItems: [],
  searchQuery: '',
  filters: {},
};

export default function catalogReducer(state = initialState, action) {
  switch (action.type) {
    case t.CATALOG_SET_PROVIDER:
      return { ...state, provider: action.payload, selectedItems: [], searchQuery: '', filters: {} };

    case t.CATALOG_ADD_SELECTED_ITEM:
      return { ...state, selectedItems: [...state.selectedItems, action.payload] };

    case t.CATALOG_REMOVE_SELECTED_ITEM:
      return { ...state, selectedItems: state.selectedItems.filter((i) => i.id !== action.payload) };

    case t.CATALOG_CLEAR_SELECTED_ITEMS:
      return { ...state, selectedItems: [] };

    case t.CATALOG_SET_SEARCH_QUERY:
      return { ...state, searchQuery: action.payload };

    case t.CATALOG_SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case t.CATALOG_RESET:
      return initialState;

    default:
      return state;
  }
}
